import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/**
 * A standing monitor for the identity Σ(movement delta) == Σ(balances held).
 * Computed independently of the balance table, so a per-user drift shows up here
 * instead of being inherited.
 */
export const ArenaOpsUsersLedgerIdentityResponseSchema = z.object({
  byType: z.array(z.object({ type: z.string(), movementCount: z.number().int(), netUsdt: ArenaOpsUsdtSchema })),
  ledgerTotalUsdt: ArenaOpsUsdtSchema,
  balancesHeldUsdt: ArenaOpsUsdtSchema,
  driftUsdt: ArenaOpsUsdtSchema,
  drifters: z.array(
    z.object({
      hubUserId: z.number().int(),
      balanceUsdt: ArenaOpsUsdtSchema,
      ledgerUsdt: ArenaOpsUsdtSchema,
      driftUsdt: ArenaOpsUsdtSchema,
    }),
  ),
});
export type ArenaOpsUsersLedgerIdentityResponse = z.infer<typeof ArenaOpsUsersLedgerIdentityResponseSchema>;
